var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row charges-extra-parameters-input-widgets"},_vm._l((_vm.sortedExtraParameters),function(ref){
var attr = ref[0];
var field = ref[1];
return _c('div',{key:field.key,class:_vm.inputClass},[_c('input-widget',{key:attr,attrs:{"model":_vm.model,"type":field.type,"rules":field.rules,"attribute":("" + attr),"label":field.label}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }